import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function digitalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const password = control.value

    const digital = /[0-9]/

    if (!digital.test(password)) {
      return {'digitalNotValid': true}
    }

    return null;

  }
}
